import { globalStyles } from "@client/shared/constants";

const style = {
  pageTitleWrapper: {
    borderRadius: 2,
  },
  tableContainer: {
    "border-radius": "10px",
    // "max-height": "300px !important",
  },
  emptyLogoDiv: {
    background: "rgb(249, 249, 249)",
    border: "1px solid rgb(220, 221, 225)",
    height: 36,
    width: 124,
  },
};

export default style;
